import { SET_MOBILE_TELEPHONY_MAIN_OPTION, SET_MOBILE_TELEPHONY_SUB_OPTION, RESET_MOBILE_TELEPHONY_OPTIONS, SET_MOBILE_TELEPHONY_COMMENTS } from "../actions/mobileTelephonyAction";

const initialState = {
    mainOption: null,
    subOption: null,
    comments: '',            
    isFullySelected: false,
};

const mobileTelephonyReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MOBILE_TELEPHONY_MAIN_OPTION:
            return {
                ...state,
                mainOption: action.payload,
                subOption: null, 
                comments: '',            
                isFullySelected: false, 
            };
        case SET_MOBILE_TELEPHONY_SUB_OPTION:
            return {
                ...state,
                subOption: action.payload,
                comments: '',
            };
        case SET_MOBILE_TELEPHONY_COMMENTS:
            return {
                ...state,
                comments: action.payload,
                isFullySelected: state.mainOption !== null && state.subOption !== null && action.payload.trim() !== '',
            };
        case RESET_MOBILE_TELEPHONY_OPTIONS:
            return {
                ...state,
                mainOption: null,
                subOption: null,
                comments: '',            
                isFullySelected: false,
            };
        default:
            return state;
    }
};

export default mobileTelephonyReducer;
